import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormikContext, FieldArray } from "formik";
import SectionHeading from "../common/SectionHeading";
import DynamicFieldGroup from "../common/DynamicFieldGroup";
import CloseIcon from "@mui/icons-material/Close";

const AccestList = ({ formField }) => {
  const {
    realEstateAssets,
    goldValue,
    policyValue,
    bankFdValue,
    cashInBankValue,
    businessInvestmentValue,
    vehicleCarValue,
  } = formField;

  const { values, setFieldValue, errors, touched } = useFormikContext();
  //  console.log("form field values access list", values);
  const assetTypes = ["Flat", "Land", "Plot", "Shop"];
  const isSmallDevice = useMediaQuery("(max-width:600px)");

  // Console log the values for debugging

  return (
    <Box
      sx={{
        p: isSmallDevice ? 0.5 : 1,
        maxWidth: 1000,
        mx: "auto",
        fontSize: { xs: "0.875rem", sm: "1rem" },
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: isSmallDevice ? 2 : 3,
          position: "relative",
          border: "1px solid #e0e0e0",
          borderRadius: 3,
        }}
      >
        {/* <SectionHeading title="Asset List" number={4} /> */}
        {/* Real Estate Section */}
        <FieldArray name="accetList.realEstateAssets">
          {({ push, remove }) => (
            <div className="">
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                }}
              >
                1. Real Estate:
              </Typography>

              {values.accetList.realEstateAssets?.map((asset, index) => (
                <Box
                  key={index}
                  sx={{
                    mb: 3,
                    position: "relative",
                    p: { xs: 1, sm: 0 },

                    // mx: isSmallDevice ? -1 : 2,
                    borderRadius: 1,
                    border: "1px solid #e0e0e0",
                    // boxShadow: { xs: 2, sm: 0 },
                    // border: { xs: "1px solid #e0e0e0", sm: "none" },
                    backgroundColor: { xs: "#fff", sm: "transparent" },
                  }}
                >
                  {values.accetList.realEstateAssets.length > 1 && (
                    <IconButton
                      size="small"
                      aria-label={`remove rental ${index}`}
                      onClick={() => remove(index)}
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        backgroundColor: "rgba(0,0,0,0.04)",
                        zIndex: 5,
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                  <DynamicFieldGroup
                    showTextField={true}
                    textFields={[
                      {
                        label: "Property",
                        value: asset.property || "",
                        disable: true,
                        placeholder: "Property",
                        type: "display",
                        sx: { fontWeight: "bold" },
                      },
                      {
                        label: "Location",
                        value: asset.location || "",
                        onChange: (e) =>
                          setFieldValue(
                            `accetList.realEstateAssets[${index}].location`,
                            e.target.value,
                          ),
                        placeholder: "Location",
                        type: "text",
                      },
                    ]}
                    showDropdown={true}
                    dropdownOptions={assetTypes}
                    dropdownValue={asset.assetType || ""}
                    onDropdownChange={(e) =>
                      setFieldValue(
                        `accetList.realEstateAssets[${index}].assetType`,
                        e.target.value,
                      )
                    }
                    dropdownLabel="Asset Type"
                    showSlider={true}
                    sliderValue={asset.value || 0}
                    onSliderChange={(e, newValue) => {
                      setFieldValue(
                        `accetList.realEstateAssets[${index}].value`,
                        newValue,
                      );
                    }}
                    sliderMin={0}
                    sliderMax={1000000000}
                    sliderStep={10000}
                    showInputField={true}
                    inputValue={asset.value || ""}
                    onInputChange={(e) => {
                      const newValue = Number(e.target.value) || 0;
                      setFieldValue(
                        `accetList.realEstateAssets[${index}].value`,
                        newValue,
                      );
                    }}
                    inputLabel="Value ₹"
                    inputType="number"
                    showRemoveButton={false}
                    onRemove={() => remove(index)}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr " },
                      gap: 2,
                      marginTop: isSmallDevice ? 3.5 : 0,
                    }}
                  />
                </Box>
              ))}

              {/* Add Real Estate Button */}
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() =>
                    push({
                      property: `Property ${values.accetList.realEstateAssets.length + 1}`,
                      location: "",
                      assetType: "",
                      value: 0,
                    })
                  }
                >
                  + Add Real Estate
                </button>
              </div>
            </div>
          )}
        </FieldArray>

        {/* Gold Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 1,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            2. Gold:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.accetList?.goldValue || 0}
            onSliderChange={(e, newValue) =>
              setFieldValue("accetList.goldValue", newValue)
            }
            sliderMin={0}
            sliderMax={10000000}
            sliderStep={1000}
            showInputField={true}
            inputValue={values.accetList?.goldValue || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("accetList.goldValue", newValue);
            }}
            inputLabel="Value ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </Box>

        {/* Policy/PF Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 1,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            3. Policy/PF:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.accetList?.policyValue || 0}
            onSliderChange={(e, newValue) =>
              setFieldValue("accetList.policyValue", newValue)
            }
            sliderMin={0}
            sliderMax={10000000}
            sliderStep={1000}
            showInputField={true}
            inputValue={values.accetList?.policyValue || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("accetList.policyValue", newValue);
            }}
            inputLabel="Value ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </Box>

        {/* Bank FD Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            4. Bank FD:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.accetList?.bankFdValue || 0}
            onSliderChange={(e, newValue) =>
              setFieldValue("accetList.bankFdValue", newValue)
            }
            sliderMin={0}
            sliderMax={100000000}
            sliderStep={10000}
            showInputField={true}
            inputValue={values.accetList?.bankFdValue || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("accetList.bankFdValue", newValue);
            }}
            inputLabel="Value ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </Box>

        {/* Cash in Bank Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            5. Cash in Bank:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.accetList?.cashInBankValue || 0}
            onSliderChange={(e, newValue) =>
              setFieldValue("accetList.cashInBankValue", newValue)
            }
            sliderMin={0}
            sliderMax={100000000}
            sliderStep={10000}
            showInputField={true}
            inputValue={values.accetList?.cashInBankValue || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("accetList.cashInBankValue", newValue);
            }}
            inputLabel="Value ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </Box>

        {/* Total Present Business Investment Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            6. Total Present Business Investment:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.accetList?.businessInvestmentValue || 0}
            onSliderChange={(e, newValue) =>
              setFieldValue("accetList.businessInvestmentValue", newValue)
            }
            sliderMin={0}
            sliderMax={1000000000}
            sliderStep={100000}
            showInputField={true}
            inputValue={values.accetList?.businessInvestmentValue || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("accetList.businessInvestmentValue", newValue);
            }}
            inputLabel="Value ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </Box>

        {/* Vehicle & Car Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            7. Vehicle & Car:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.accetList?.vehicleCarValue || 0}
            onSliderChange={(e, newValue) =>
              setFieldValue("accetList.vehicleCarValue", newValue)
            }
            sliderMin={0}
            sliderMax={100000000}
            sliderStep={10000}
            showInputField={true}
            inputValue={values.accetList?.vehicleCarValue || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("accetList.vehicleCarValue", newValue);
            }}
            inputLabel="Value ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default AccestList;
